import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { Drawer, IconButton } from '@themenu/design-system'

import { Menu } from 'components/Navigation/Menu'

import { UserMenu } from './components/UserMenu'
import NotificationArea from './components/NotificationArea'

const isNotificationEnabled =
  process.env.NEXT_PUBLIC_IS_NOTIFICATION_ENABLED === 'true'

export const Header = () => {
  const router = useRouter()

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    const closeMenu = () => setIsMenuOpen(false)

    window.addEventListener('resize', closeMenu)
    router.events.on('routeChangeStart', closeMenu)

    return () => {
      window.removeEventListener('resize', closeMenu)
      router.events.off('routeChangeStart', closeMenu)
    }
  }, [router.events])

  return (
    <>
      <header className="flex justify-between gap-16 items-center h-[50px] px-8 md:px-24 md:justify-end">
        <IconButton
          aria-label={'Abrir menu lateral'}
          name="list-reorder"
          size={32}
          variant="text"
          className="block md:hidden"
          onClick={() => setIsMenuOpen(true)}
        />
        {isNotificationEnabled && <NotificationArea />}
        <UserMenu />
      </header>

      <Drawer
        isOpen={isMenuOpen}
        title={'swile'}
        onClose={() => setIsMenuOpen(false)}
        className="bg-background-contrast"
      >
        <Menu />
      </Drawer>
    </>
  )
}
